export const isDespiaNative = () => {
  if (typeof navigator === "undefined") return false;
  return navigator.userAgent.toLowerCase().includes("despia");
};

/**
 * True when running inside the Despia native wrapper on Android (i.e. native
 * but not iOS). Mirrors detectPlatform() in src/lib/apple-auth.ts. Used to add
 * the `despia-android` class on <html>, which drives the extra bottom safe-area
 * clearance (the Android WebView reports env(safe-area-inset-bottom)=0 even with
 * a system nav bar visible). iOS and web are unaffected.
 */
export const isDespiaAndroid = () => {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes("despia") && !/iphone|ipad|ipod/.test(ua);
};
